// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2019":"0cf120cc","2081":"ca833824","5873":"3b498c01","7531":"28c1df94"}[chunkId] + ".chunk.css";
};